// extracted by mini-css-extract-plugin
module.exports = {"title":"_513741","root":"_c091f7","content":"_2f3057"};